<div>
  <p-dataView [value]="schemaDisplay().projectDescriptorCategories">
    <ng-template #emptymessage>
      <p-skeleton styleClass="mb-2" />
      <p-skeleton width="10rem" styleClass="mb-2" />
      <p-skeleton styleClass="mb-2" />
      <p-skeleton width="10rem" styleClass="mb-2" />
    </ng-template>
    <ng-template #list let-categories >
      <div class="grid grid-nogutter">
        <!-- div class="flex flex-wrap p-1 items-center gap-3" -->
        @for (c of categories; track c) {
          <div class="col-span-12 pb-3">
            @if (ProjectSchemas.getVariantByCategoryAndUse(c, use()) != null) {
            <project-descriptor-category [schemaDisplay]="schemaDisplay()" [variant]="ProjectSchemas.getVariantByCategoryAndUse(c, use())" [profileGroup]="profileGroup()" [use]="use()" [category]="c" />
            }
          </div>
        }
      </div>
    </ng-template>
  </p-dataView>
</div>
